import type { TrackingContext } from '@mentimeter/http-clients';
import { useFlag } from '@mentimeter/flags/confidence/client';
import { ViewOnlyAuthButtons } from 'features/core/editor/Header/view-only/ViewOnlyAuthButtons';
import { Box } from '@mentimeter/ragnar-ui/box';
import { useSearchParams } from '@mentimeter/next-navigation';
import { FOOTER_ACTIONS_HEIGHT_MOBILE } from '@mentimeter/editor-properties-pane';
import { ViewOnlyCommentDrawer } from './ViewOnlyCommentDrawer';
import { ViewOnlyCommentDrawerExperiment } from './ViewOnlyCommentDrawerExperiment';

export type DiscussResultsExperimentVersion = 'off' | 'chat' | 'comment';
const getDiscussResultsExperimentVersion = (
  eligibleForDiscussResultsExperimentSearchParam: string | null,
  discussResultsExperiment: string | null,
  isVisitor: boolean,
): DiscussResultsExperimentVersion => {
  if (!isVisitor) return 'off';
  if (eligibleForDiscussResultsExperimentSearchParam !== 'true') return 'off';
  return (discussResultsExperiment as DiscussResultsExperimentVersion) ?? 'off';
};

export const ViewOnlyFooter = ({
  isVisitor,
  buttonSize,
  seriesId,
  trackingContext,
  isCommentDrawerOpen,
  isShared,
  currentPlan,
  roleInWorkspace,
}: {
  isVisitor: boolean;
  buttonSize: 'default' | 'compact';
  seriesId: string;
  trackingContext: TrackingContext;
  isCommentDrawerOpen: boolean;
  isShared: boolean;
  currentPlan: string;
  roleInWorkspace: string;
}) => {
  const searchParams = useSearchParams();
  const eligibleForDiscussResultsExperimentSearchParam =
    searchParams.get('discuss-results');

  const { value: discussResultsExperiment } = useFlag(
    'bees-discuss-results.version',
    'off',
  );

  const discussResultsExperimentVersion = getDiscussResultsExperimentVersion(
    eligibleForDiscussResultsExperimentSearchParam,
    discussResultsExperiment,
    isVisitor,
  );

  if (isVisitor)
    if (discussResultsExperimentVersion !== 'off') {
      return (
        <ViewOnlyCommentDrawerExperiment
          version={discussResultsExperimentVersion}
        />
      );
    } else {
      return (
        <Box
          bg="bg"
          alignItems="center"
          flexDirection="row"
          justifyContent="center"
          height={FOOTER_ACTIONS_HEIGHT_MOBILE}
          width="100%"
        >
          <ViewOnlyAuthButtons
            buttonSize={buttonSize}
            seriesId={seriesId}
            trackingContext={trackingContext}
          />
        </Box>
      );
    }

  return (
    <ViewOnlyCommentDrawer
      open={isCommentDrawerOpen}
      isShared={isShared}
      currentPlan={currentPlan}
      roleInWorkspace={roleInWorkspace}
      trackingContext={trackingContext}
    />
  );
};
